/* eslint-disable react/prop-types */
import React from 'react';
import styled from 'styled-components';

const HEIGHT = '1.5rem';
const WIDTH = '3rem';

const Switch = styled.input`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  opacity: 0;
  cursor: pointer;
  &:checked {
    + label {
      background-color: #4bd865;
      &:after {
        left: ${HEIGHT};
      }
    }
  }
`;

const ToggleLabel = styled.label`
  width: ${WIDTH};
  height: ${HEIGHT};
  background: #ccc;
  position: relative;
  display: inline-block;
  border-radius: 46px;
  transition: 0.4s;
  box-sizing: border-box;
  &:after {
    content: '';
    position: absolute;
    width: ${HEIGHT};
    height: ${HEIGHT};
    border-radius: 100%;
    left: 0;
    top: 0;
    z-index: 2;
    background: #fff;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    transition: 0.4s;
  }
`;

const ToggleButton = styled.div`
  position: relative;
  width: ${WIDTH};
  height: ${HEIGHT};
`;

function ToggleSwitch({ onChange, ...props }) {
  function onToggle(evt) {
    if (evt.target.checked) {
      const event = Object.assign({}, evt);
      event.target.value = true;
      onChange(event);
    } else {
      const event = Object.assign({}, evt);
      event.target.value = false;
      onChange(event);
    }
  }

  return (
    <ToggleButton>
      <Switch
        id="toggle-switch"
        type="checkbox"
        onClick={onToggle}
        {...props}
      />
      <ToggleLabel />
    </ToggleButton>
  );
}

export default ToggleSwitch;
